import { useState } from "react";

/**
 * Hook para gestionar estado de modales
 * @param {boolean} initialState - Estado inicial
 * @returns {object} { isOpen, open, close, toggle, data, setData }
 */
export const useModal = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const [data, setData] = useState(null);

  const open = (modalData = null) => {
    setData(modalData);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setTimeout(() => setData(null), 300);
  };

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  return {
    isOpen,
    open,
    close,
    toggle,
    data,
    setData,
  };
};
